"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
import { Button } from "@/components/ui/button";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to Sentry
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex flex-col align-middle items-center justify-center w-full h-full">
    <h1 className="text-8xl mb-8"> &#129300;</h1>
      <h1 className="mb-8 font-bold">Oops: une erreur s&lsquo;est produite !</h1>
      <Button className="form-btn"
        onClick={
          () => reset()
        }
      >
        Essayez de nouveau !
      </Button>
  </div>
  );
}
